import styled from 'styled-components';
import { respond } from '../../../theme/mixins';

const SLIDE_IN_ELLIPTIC_TOP_FWD =
  'slide-in-elliptic-top-fwd 0.7s cubic-bezier(0.250, 0.460, 0.450, 0.940) both';

const SCALE_IN_CENTER =
  'scale-in-center 0.3s cubic-bezier(0.250, 0.460, 0.450, 0.940) both';

const BOUNCE_IN_FWD = 'bounce-in-fwd 1s both';

export const VideoWrapper = styled.div`
  width: 100%;
  // height: calc(100vh - 104px);
  height: calc(100vh);
  position: relative;
  margin: 0 auto;
  overflow: hidden;

  .spinner-crescent {
    height: 180px;
    width: 180px;
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    z-index: 10;
    transform: translateY(-50%);
    top: 50%;
  }
  .video-js {
    width: 100%;
    margin: 0 auto;
    /* height: calc(100% - 50px); */
    height: 100% !important;
    position: absolute;
    padding: 0;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    border-radius: 0;
    box-shadow: 1px 1px 18px -1px #000;
    z-index: 11;
    &.no-clicks {
      pointer-events: none;
    }

    button {
      outline: 0;
      &.vjs-big-play-button {
        right: 0;
        left: 0;
        margin: 0 auto;
        top: 50%;
        transform: translateY(-50%);
        padding: 0;
        border: none;
        background: #00000070;
        border-radius: 50%;
        width: 90%;
        max-width: 65px;
        display: flex;
        align-items: center;
        justify-content: center;
        height: auto;
        box-shadow: 1px 1px 30px 5px #0000006e;
        transition: 0.2s;
        z-index: 20;
        &:hover {
          background: #145dce;
        }
        .vjs-icon-placeholder {
          display: flex;
          height: 60px;
          align-items: center;
          justify-content: center;
          &:before {
            font-size: 3rem;
            position: relative;
            display: block;
            height: auto;
          }
        }
      }
    }

    &.vjs-playing {
      .vjs-big-play-button {
        display: none;
      }
    }
    * {
      box-sizing: border-box;
    }
    &.vjs-controls-disabled {
      .vjs-big-play-button {
        display: none;
      }
      .vjs-tech {
        pointer-events: none;
      }
    }
    &.show-end-screen {
      .vjs-tech {
        object-fit: cover;
      }
    }

    .vjs-tech {
      /* object-fit: cover; */
      outline: 0;
      border-radius: 0;
      height: 100%;
      &.blur {
        filter: blur(8px);
      }
    }
    .vjs-modal-dialog {
      background: none;
      color: #444;
      position: absolute;
      left: 0;
      right: 0;
      margin: 0 auto;
      width: auto;
      padding: 0;
      bottom: 60px;
      top: initial;
      box-sizing: border-box;
      height: auto;
      transition: 0.6s ease-in-out;
      opacity: 0;
      overflow: visible;
      max-width: 80%;

      .vjs-modal-dialog-content {
        position: relative;
        font-size: initial;
        line-height: initial;
        padding: 0;
        width: auto;
        height: auto;
      }
      * {
        box-sizing: border-box;
      }

      &.pos-top-left {
        top: 40px;
        bottom: initial;
        right: initial;
        left: 90px;
        &:after {
        }
      }
      &.pos-top-right {
        top: 40px;
        bottom: initial;
        left: initial;
        right: 20px;
      }
      &.pos-bottom-left {
        top: initial;
        bottom: 90px;
        left: 90px;
        right: initial;
      }
      &.pos-bottom-right {
        top: initial;
        bottom: 90px;
        left: initial;
        right: 20px;
      }

      &.show-modal {
        opacity: 1;
        -webkit-animation: ${BOUNCE_IN_FWD};
        animation: ${BOUNCE_IN_FWD};
      }
    }
    .vjs-slider {
      border-radius: 50px;
    }
    .vjs-control {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.85rem;
      height: 50px;
      &.vjs-time-control,
      &.vjs-playback-rate,
      &.vjs-picture-in-picture-control {
        display: none;
      }
    }

    .vjs-button {
      > .vjs-icon-placeholder {
        &:before {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 2rem;
        }
      }
    }
    .vjs-playback-rate > .vjs-menu-button,
    .vjs-playback-rate .vjs-playback-rate-value {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .vjs-fullscreen-control {
      /* position: absolute;
          right: -210px; */
      z-index: 10;
      left: 0;
      margin: 0 auto;
    }
    .vjs-volume-panel {
      /* position: absolute;
          left: -240px; */
      z-index: 10;
      right: 0;
      margin: 0 auto;
      .vjs-mute-control {
        width: 3em;
      }
      .vjs-slider-horizontal .vjs-volume-level:before {
        color: var(--ion-color-light);
        top: -0.4em;
        right: -0.5em;
        font-size: 1rem;
      }
      .vjs-slider {
        width: 6em;
        /* height: 0.5em; */
        height: 0.8em;
        background: #9797a257;
      }
      .vjs-volume-level {
        /* background: var(--ion-color-primary); */
        background-color: #fff;
        top: 0;
        bottom: 0;
        height: 100%;
        border-radius: 50px;
        &:before {
          display: none;
        }
      }

      .vjs-mute-control ~ .vjs-volume-control.vjs-volume-horizontal,
      .vjs-volume-control {
        visibility: visible;
        opacity: 1;
        position: relative;
        width: 7em;
        height: 3em;
        margin-right: 0;
      }
      &.vjs-volume-panel-horizontal {
        width: 10em;
      }
      .vjs-icon-placeholder {
        &:before {
          font-size: 1.7rem;
        }
      }
    }
    .vjs-time-tooltip {
      font-size: 1rem !important;
      border-radius: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 7px 10px;
      background: rgba(255, 255, 255, 0.9);
      color: #555;
      font-weight: 600;
    }
    .vjs-mouse-display .vjs-time-tooltip {
      background: var(--ion-color-primary);
      color: #fff;
    }
    .vjs-control-bar {
      background-color: rgba(43, 51, 63, 0.9);
      background-color: rgba(43, 51, 63, 0.8);
      transition: 0.2s;
      align-items: flex-end;
      justify-content: center;
      height: 70px;
      z-index: 20;
      width: 100%;
      padding: 10px 40px;
      box-shadow: 1px 1px 20px -5px #0000009c;
      &:hover {
        background-color: rgba(43, 51, 63, 0.7);
      }
    }

    .vjs-progress-control {
      /* position: absolute;
          left: 0;
          right: 0;
          width: 90%;
          top: -60px;
          margin: 0 auto;
          background: #00000087; */
      height: 53px;
      border-radius: 10px;
      display: block;
      .vjs-progress-holder {
        height: 0.5em;
        width: 92%;
        margin: 0 auto;
        position: absolute;
        left: 0;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
      }
      &:hover .vjs-progress-holder {
        font-size: inherit;
      }
    }

    .vjs-play-progress {
      background: #2de42d;
      border-radius: 50px;
      &:before {
        font-size: 1.2rem;
        top: 0em;
        right: -0.4em;
      }
    }

    &.vjs-live:not(.vjs-liveui),
    &:not(.vjs-live) {
      .vjs-seek-to-live-control {
        display: none;
      }
    }
    &.response-video {
      height: 250px !important;
      position: relative;
      width: auto;
      margin: 0 auto;
      box-shadow: none;
      overflow: visible;
      border-radius: 8px;
      background: none;

      .vjs-tech {
        border-radius: 8px;
      }
      .vjs-control-bar {
        background-color: rgba(43, 51, 63, 0.3);
        transition: 0.2s;
        border-radius: 0 0 15px 15px;
        &:hover {
          background-color: rgba(43, 51, 63, 0.7);
        }
      }
      .vjs-control-bar {
        align-items: center;
        justify-content: center;
        height: 50px;
        padding: 0;
      }
      .vjs-progress-control,
      .vjs-play-control,
      .vjs-volume-panel,
      .vjs-fullscreen-control {
        position: relative;
        left: initial;
        right: initial;
        top: initial;
        bottom: initial;
        .vjs-icon-placeholder:before {
          font-size: 1.5rem;
        }
      }
      .vjs-play-control,
      .vjs-fullscreen-control {
        width: 4em;
      }
      .vjs-volume-panel {
        width: 6em;
        position: absolute;
        top: 57px;
        left: 27px;
        height: 3em;
        .vjs-slider {
          width: 6em;
          height: 0.7em;
          border-radius: 50px;
        }
        .vjs-volume-level {
          background: var(--ion-color-primary);
          top: 0;
          bottom: 0;
          height: 100%;
          border-radius: 50px;
          &:before {
            display: none;
          }
        }
        .vjs-icon-placeholder:before {
          color: #444;
        }
      }
    }
  }
  .vjs-marker {
    width: 23px;
    border-radius: 50%;
    background-color: #0000008a;
    height: 23px;
    top: -8px;
    position: absolute;
    z-index: 1;
    transition: 0.1s;
    border: 2px solid #ffffffad;
    /* opacity: 0; */
    &.vjs-marker-active,
    &.vjs-marker-completed {
      background-color: var(--ion-color-primary);
      width: 23px;
      height: 23px;
      top: -8px;
      margin-left: -1px !important;
      box-shadow: -2px 0px 9px 4px #0d170d69;
      opacity: 1;
      &.vjs-marker-completed {
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(24, 197, 13, 1);
        width: 25px;
        height: 25px;
        top: -10px;
        &:after {
          content: '\f00c';
          color: #ffffff;
          font-size: 0.85rem;
          padding: 0;
          border: none;
          font-weight: 900;
          position: relative;
          top: 1px;
        }
        &.vjs-marker-active {
          &:before {
            content: '\f35b';
            color: var(--ion-color-primary);
            font-size: 1.1rem;
            padding: 2px;
            border: none;
            font-weight: 900;
            position: absolute;
            top: -30px;
            background: #fff;
            border-radius: 50%;
          }
        }
      }
    }
    &.vjs-marker-active {
      -webkit-animation: pulsate-fwd 1s ease-in-out infinite both;
      animation: pulsate-fwd 1s ease-in-out infinite both;
    }
    &:not(.vjs-marker-disabled):not(.vjs-marker-active):hover {
      cursor: pointer;
      background-color: #329254;
    }
  }
`;
